import { RefreshCcw } from "lucide-react";
import React, { FC } from "react";

import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { styled, useTheme } from "@mui/material";

import { IgCustomTheme, StripeColor } from "./theme";

const StyledButton = styled(LoadingButton)(({ theme }) => ({
  // textTransform: "none",
}));

const LoadingStyledButton = styled(LoadingButton)(({ theme }) => ({
  minHeight: "40px",
  textTransform: "none",
  color: (theme as IgCustomTheme).igBackgroundColors.interactive.accent.default,
  backgroundColor: (theme as IgCustomTheme).igBackgroundColors.interactive
    .neutral.default,
  "&:hover, &:focus": {
    // color: ColorPrimary.main,
    backgroundColor: (theme as IgCustomTheme).igBackgroundColors.interactive
      .neutral.default,
    cursor: "auto",
  },
}));

const StripeStyledButton = styled(LoadingButton)(({ theme }) => ({
  minHeight: "40px",
  textTransform: "none",
  color: "white",
  backgroundColor: StripeColor,
  "&:hover, &:focus": {
    color: "white",
    backgroundColor: "#4d46c6",
  },
}));

export interface IgButtonProps extends LoadingButtonProps {
  igVariant?: "warning" | "error" | "success" | "loading" | "stripe";
  component?: any;
}

/**
 * @see LoadingButton
 */
export const IgButton: FC<IgButtonProps> = (props) => {
  const theme = useTheme<IgCustomTheme>();
  const defaultProps = theme.components?.MuiButton?.defaultProps;

  const { igVariant, ...defaultVariantProps } = props;
  const {
    children,
    onClick,
    loading,
    sx,
    variant = defaultProps?.variant,
    color = defaultProps?.color,
    ...rest
  } = defaultVariantProps;

  if (igVariant === "loading") {
    return (
      // @ts-ignore
      <LoadingStyledButton
        startIcon={<RefreshCcw size={16} className={"spin"} />}
        disableElevation
        loading={loading}
        variant={"contained"}
        {...rest}
        // @ts-ignore
        sx={{ ...sx }}
        onClick={undefined}
      >
        {children}
      </LoadingStyledButton>
    );
  }

  if (igVariant === "stripe") {
    return (
      <StripeStyledButton
        disableElevation
        loading={loading}
        variant={"contained"}
        {...rest}
        sx={{ ...sx }}
        onClick={Boolean(loading) && Boolean(onClick) ? undefined : onClick}
      >
        {children}
      </StripeStyledButton>
    );
  }

  return (
    <StyledButton
      disableElevation
      sx={
        variant === "text"
          ? {
              "& .MuiLoadingButton-loadingIndicator": {
                paddingRight: "50px",
              },
            }
          : undefined
      }
      {...defaultVariantProps}
      variant={variant}
      color={color}
      onClick={Boolean(loading) && Boolean(onClick) ? undefined : onClick}
    >
      {!loading && children}
    </StyledButton>
  );
};
